/**
 * **Die Liste fährt mit**, wenn ein eigener Zug an ihren oberen oder unteren Rand kommt (#301) —
 * „Neue Aufgabe“ aus der Pille. Das Verschieben von Aufgaben bekommt das von dnd-kit; ein Zug
 * außerhalb von dnd-kit hätte sonst keinen Weg an Stellen außerhalb des Bilds.
 *
 * Dieselben Zahlen wie das Mitfahren der Pinnwand (`autoPanDelta`, 40px Zone, Tempo 15): Wer an den
 * Rand fährt, soll dasselbe spüren.
 *
 * Bewusst ohne React-Bezug, wie die übrigen `utils/`.
 */

/** Wie nah am Rand (in Bildschirm-Pixeln) das Fahren beginnt. */
export const EDGE_SCROLL_DISTANCE = 40
/** Pixel je Bild ganz außen. */
export const EDGE_SCROLL_SPEED = 15

/**
 * Um wie viele Pixel die Liste in diesem Bild scrollt: negativ nach oben, positiv nach unten, 0
 * innerhalb. In der Zone wächst das Tempo linear zur Kante; jenseits der Kante bleibt es voll.
 *
 * @param pointerY  Zeiger auf dem Bildschirm
 * @param viewport  sichtbarer Bereich der Liste auf dem Bildschirm (ohne Verläufe und Pille, wenn
 *                  dort nichts zu treffen ist)
 *
 * @example
 * edgeScrollDelta(105, { top: 100, bottom: 700 })  // ≈ −13 — fast oben
 * edgeScrollDelta(400, { top: 100, bottom: 700 })  // 0
 */
export function edgeScrollDelta(pointerY: number, viewport: { top: number; bottom: number }, speed = EDGE_SCROLL_SPEED): number {
  const fromTop = pointerY - viewport.top
  const fromBottom = viewport.bottom - pointerY
  if (fromTop < EDGE_SCROLL_DISTANCE) return -speed * strength(fromTop)
  if (fromBottom < EDGE_SCROLL_DISTANCE) return speed * strength(fromBottom)
  return 0
}

/** 0 am inneren Rand der Zone, 1 an der Kante und dahinter. */
function strength(distance: number): number {
  return Math.min(1, Math.max(0, (EDGE_SCROLL_DISTANCE - distance) / EDGE_SCROLL_DISTANCE))
}
